import React from 'react';
import { motion } from 'framer-motion';
import { SectionWrapper, childVariants } from './SectionWrapper';
export function ProblemSection() {
  return <SectionWrapper alternate data-id="element-395">
      <motion.h2 className="font-heading text-2xl md:text-3xl font-bold text-cream mb-10" variants={childVariants} data-id="element-396">
        The problem nobody warns you about
      </motion.h2>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-8" variants={childVariants} data-id="element-397">
        Most sleep advice is built for people who can't <em data-id="element-398">fall</em> asleep.
      </motion.p>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-8" variants={childVariants} data-id="element-399">
        But if you're a woman 45+, the real sabotage often looks like this:
      </motion.p>

      <motion.ul className="space-y-4 mb-10" variants={childVariants} data-id="element-400">
        <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-401">
          <span className="mt-2 w-2 h-2 rounded-full bg-teal flex-shrink-0" data-id="element-402" />
          You fall asleep fine
        </li>
        <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-403">
          <span className="mt-2 w-2 h-2 rounded-full bg-teal flex-shrink-0" data-id="element-404" />
          You wake up between 2–4am
        </li>
        <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-405">
          <span className="mt-2 w-2 h-2 rounded-full bg-teal flex-shrink-0" data-id="element-406" />
          Your body feels hot, jittery, or alert
        </li>
        <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-407">
          <span className="mt-2 w-2 h-2 rounded-full bg-teal flex-shrink-0" data-id="element-408" />
          Your brain starts sprinting
        </li>
        <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-409">
          <span className="mt-2 w-2 h-2 rounded-full bg-teal flex-shrink-0" data-id="element-410" />
          You try to "figure it out"
        </li>
        <li className="flex items-start gap-3 font-body text-lg text-amber font-medium leading-relaxed-plus" data-id="element-411">
          <span className="mt-2 w-2 h-2 rounded-full bg-amber flex-shrink-0" data-id="element-412" />
          And suddenly you're not just awake… you're up
        </li>
      </motion.ul>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-6" variants={childVariants} data-id="element-413">
        Then you pay for it all day:
      </motion.p>

      <motion.p className="font-body text-lg text-cream-muted leading-loose-plus mb-10 pl-4 border-l-2 border-amber/30" variants={childVariants} data-id="element-414">
        foggy, thin-skinned, cravings, headaches, anxiety spikes, no patience,
        zero capacity.
      </motion.p>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-4" variants={childVariants} data-id="element-415">
        And the worst part?
      </motion.p>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-4" variants={childVariants} data-id="element-416">
        At night you start <em className="text-amber" data-id="element-417">bracing</em> for it.
      </motion.p>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-4" variants={childVariants} data-id="element-418">
        You go to bed already afraid of 3am.
      </motion.p>

      <motion.p className="font-heading text-xl text-cream-muted italic leading-relaxed-plus" variants={childVariants} data-id="element-419">
        That fear becomes the invitation.
      </motion.p>
    </SectionWrapper>;
}